import styled from 'styled-components';
export const StyledWrapper = styled.div`
	.checkbox-apple {
		height: 25px;
		margin: 20px;
		position: relative;
		user-select: none;
		width: 50px;
	}

	.checkbox-apple label {
		background: linear-gradient(to bottom, #b3b3b3, #e6e6e6);
		border-radius: 50px;
		cursor: pointer;
		height: 25px;
		left: 0;
		position: absolute;
		top: 0;
		transition: background 0.3s ease;
		width: 50px;
	}

	.checkbox-apple label::after {
		background-color: #fff;
		border-radius: 50%;
		box-shadow: 0 1px 3px #000;
		content: '';
		height: 23px;
		left: 1px;
		position: absolute;
		top: 1px;
		transition: transform 0.3s ease, box-shadow 0.3s ease;
		width: 23px;
	}

	.checkbox-apple input[type='checkbox']:checked + label {
		background: linear-gradient(to bottom, #4cd964, #5de24e);
	}

	.checkbox-apple input[type='checkbox']:checked + label::after {
		transform: translateX(25px);
	}

	.checkbox-apple label:hover {
		background: linear-gradient(to bottom, #b3b3b3, #e6e6e6);
	}

	.checkbox-apple label:hover::after {
		box-shadow: 0 1px 3px #000;
	}

	.yep {
		height: 25px;
		left: 0;
		position: absolute;
		top: 0;
		visibility: hidden;
		width: 50px;
	}
`;
